import { AI_PROMPT_SUGGESTION_IDS } from '../../../chatView/aiPromptSuggestions';

export const TRANSLATION_PREFIX = 'STATIC.TOPBAR_HEADERS.ASK_SINGULAR_AI';
export const ANALYSIS_CHAT_HASH = '#/react/analysis-chat';
export const MIXPANEL_PREFIX = 'Quick Agent';
export const STARTING_DELAY_MS = 650;

const SUGGESTION_ICONS = {
    COMPARE_PERFORMANCE: 'chart-bar',
    SUMMARIZE_ACTIVITY: 'file-text',
    EXPLAIN_DECREASE: 'chart-line',
    BUILD_DASHBOARD: 'layout-dashboard',
};

export const SUGGESTIONS = AI_PROMPT_SUGGESTION_IDS.map(id => ({ id, icon: SUGGESTION_ICONS[id] }));
